module.exports = "<p>\n  page-not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.component.html
// module id = 211
// module chunks = 1